import { IconSunset2 } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { WeatherCaptureBlock as RenderWeatherCaptureBlock } from '../../templateRenderer/CaptureBlocks/WeatherCaptureBlock'
import { WeatherDisplayBlock as RenderWeatherDisplayBlock } from '../../templateRenderer/DisplayBlocks/WeatherDisplayBlock'
import { WeatherCaptureBlock, WeatherDisplayBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  TypeOption,
} from './_BaseBlockConfig'

class Config extends BaseBlockConfig<WeatherCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'weather' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Weather',
    icon: IconSunset2,
    helpText: 'Capture the weather and temperature',
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
  }

  public override blockFieldsConfig: Field[] = []

  public override mapFormValueToBlock(
    block: WeatherCaptureBlock,
    value: WeatherCaptureBlock['value']
  ): WeatherCaptureBlock {
    return { ...block, value }
  }

  public override renderBlock(
    block: WeatherCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderWeatherCaptureBlock block={block} rules={rules} />
  }

  public override renderDisplayBlock(
    block: WeatherDisplayBlock
  ): React.ReactNode {
    return <RenderWeatherDisplayBlock block={block} />
  }
}

export const WeatherCaptureBlockConfig = new Config()
